<div class="card monsido-panel mt-3 mx-3">
  <div class="card-header">
    <h3 class="font-weight-300">Upload and Map CSV</h3>
  </div>
  <div class="card-body">
    <p class="step-description">Upload your CSV file and map the columns to accessibility check fields.</p>

    @if (errorMessage) {
      <div class="alert alert-danger" role="alert">
        {{ errorMessage }}
      </div>
    }

    <div class="upload-section">
      <label class="form-label">Select CSV File</label>
      <input 
        type="file" 
        class="form-control" 
        accept=".csv"
        (change)="onFileSelected($event)">
      @if (file) {
        <small class="text-muted">Selected: {{ file.name }}</small>
      }
    </div>

    @if (showPreview) {
      <div class="mapping-section">
        <h6>Field Mapping</h6>
        <p class="text-muted">Map your CSV columns to accessibility check fields. Required fields are marked with *</p>
        
        <div class="mapping-grid">
          @for (mapping of fieldMappings; track mapping.checkField) {
            <div class="mapping-row">
              <label class="mapping-label">
                {{ mapping.label }}
                @if (mapping.required) {
                  <span class="text-danger">*</span>
                }
              </label>
              <select class="form-select" [(ngModel)]="mapping.csvColumn">
                <option value="">-- Select Column --</option>
                @for (header of csvHeaders; track header) {
                  <option [value]="header">{{ header }}</option>
                }
              </select>
            </div>
          }
        </div>
      </div>

      <div class="preview-section">
        <h6>Preview (first 5 rows)</h6>
        <div class="table-responsive">
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th>Row</th>
                @for (mapping of fieldMappings; track mapping.checkField) {
                  @if (mapping.csvColumn) {
                    <th>{{ mapping.label }}</th>
                  }
                }
              </tr>
            </thead>
            <tbody>
              @for (row of previewRows; track $index) {
                <tr>
                  <td>{{ $index + 2 }}</td>
                  @for (mapping of fieldMappings; track mapping.checkField) {
                    @if (mapping.csvColumn) {
                      <td>{{ row[mapping.csvColumn] || '-' }}</td>
                    }
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
  </div>
</div>
